<template>
    <div>
        <transition name="fade">
            <div v-if="loaded && !cart.products.length" class="alert alert-warning my-4">
                {{ t.cart.empty_cart }}
            </div>
        </transition>
        <div v-if="loaded && cart.products.length" class="row">
            <div class="col-12 col-lg-9">
                <transition-group name="fade">
                    <div class="row py-4 border-bottom" v-for="product in cart.products" :key="product.index">
                        <div class="col-md-3 mb-3 mb-md-0">
                            <a :href="product.url">
                                <img :src="product.thumbnail" alt="" class="img-fluid">
                            </a>
                        </div>
                        <div class="col-md-5 align-self-center">
                            <div>
                                <div class="h5 mb-2">
                                    <a :href="product.url">
                                        {{product.name}}
                                    </a>
                                </div>
                                <div class="d-none d-lg-block mb-2" v-html="truncateText(product.description, 50)"></div>
                                <div class="mb-2" v-if="product.product_variation_attributes">
                                    <div v-for="(prod_var_attr, index) in product.product_variation_attributes" :key="index"><b>{{prod_var_attr.attribute.name}}</b>: {{prod_var_attr.value.name}}</div>
                                </div>
                                <div class="text-secondary fw-bold mb-2">{{ amountWithCurrency(product.price) }}</div>
                                <div v-if="config.modules.gift">
                                    <label :for="'is_gift_'+product.index" v-if="settings.gift_price">
                                        <input type="checkbox" :id="'is_gift_'+product.index" v-model="product.is_gift" @change="updateProduct(product)"> {{ t.cart.is_gift }} <span class="text-secondary">(+{{ amountWithCurrency(settings.gift_price) }} {{t.cart.per_item}})</span>
                                    </label>
                                    <transition name="fade">
                                        <div class="mt-2" v-if="product.is_gift">
                                            <textarea v-model="product.gift_card" class="form-control" :placeholder="t.gift_card"
                                            :maxlength="settings.gift_card_max_char"
                                            @change="updateProduct(product)"
                                            ></textarea>
                                            <div class="small text-secondary">*{{ t.cart.gift_card_max_characters}}: {{settings.gift_card_max_char}}</div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center d-none d-md-block">
                            <div class="row">
                                <div class="col-md-6 align-self-center">
                                    <div class="input-group">
                                        <span class="input-group-prepend"><button @click="product.qty--; updateProduct(product)" type="button" class="btn btn-light border">-</button></span>
                                        <input type="text"  @focus="$event.target.select()" class="form-control text-center" v-model.number="product.qty" @change="updateProduct(product)">
                                        <span class="input-group-prepend"><button @click="product.qty++; updateProduct(product)" type="button" class="btn btn-light border">+</button></span>
                                    </div>
                                </div>
                                <div class="col-md align-self-center text-center fw-bold lead">{{ amountWithCurrency(product.total) }}</div>
                                <div class="col align-self-center text-center text-secondary"><i class="fas fa-trash cursor-pointer" @click="deleteProduct(product)"></i></div>
                            </div>
                        </div>
                        <!-- Qty & Price Mobile -->
                        <div class="col-md-4 align-self-center mt-2 mt-md-0 d-md-none">
                            <input @focus="$event.target.select()" class="form-control w-25 d-inline me-3" type="number" min="0" v-model.number="product.qty" @change="updateProduct(product)">
                            <span class="fw-bold lead me-3">{{ amountWithCurrency(product.total) }}</span>
                            <span class="text-secondary"><i class="fas fa-trash cursor-pointer" @click="deleteProduct(product)"></i></span>
                        </div>
                    </div>
                </transition-group>
                <cart-vouchers-component class="mt-5"></cart-vouchers-component>
            </div>
            <div class="col">
                <div v-if="config.modules.voucher">
                    <label for="voucher">{{ t.vouchers.enter_voucher }}</label>
                    <input
                        type="text"
                        id="voucher"
                        class="form-control mb-2"
                        v-model="voucher"
                        @keypress.enter="sendVoucher()"
                    />
                    <button
                        class="btn btn-light w-100 mb-3"
                        @click="sendVoucher()"
                        autocomplete="off"
                    >
                        {{ t.vouchers.apply_voucher }}
                    </button>
                </div>
                <cart-summary-component></cart-summary-component>
                <transition name="fade">
                    <a :href="url('checkout')" class="btn btn-primary btn-lg w-100 mt-3" v-if="loaded && cart.products.length">
                        {{ t.cart.checkout }}
                    </a>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../CartStore'
    export default {
        store: store,
        data() {
            return {
                t: t,
                config: config,
                settings: settings,
                voucher: ''
            }
        },
        mounted() {
            this.$store.dispatch('getCart')
        },
        computed: {
            ...Vuex.mapGetters(['loaded', 'cart']),
        },
        methods: {
            sendVoucher() {
                this.applyVoucher(this.voucher)
                this.voucher = ''
            },
            ...Vuex.mapActions(['deleteProduct', 'updateProduct', 'applyVoucher']),
        }
    }
</script>
